module.exports = __webpack_public_path__ + "update-es2015.b22d278e2bf045d4c76d.worker.js"